import React from 'react';

import { CheckoutTopNotificationWrapper } from '../CheckoutTopNotification';
import { usePage, useField } from '@kizi/comparator-core';

interface ProviderResponse {
  data?: object[] | [];
  meta?: object | {};
  orderCompletionText?: string | '';
  statusCode: number;
}

export const CheckoutTopNotificationWrapperHTTP = ({
  unSuccesfulContent,
  succesfulContent,
}) => {
  const { state } = usePage();

  const selectedProduct = useField('overview.selectedProduct');
  const selectedProductParsed = JSON.parse(selectedProduct?.value as string);
  const provider = selectedProductParsed?.provider?.name;

  let contentFromSuccRequest = '';
  if (state?.providerRes) {
    const providerRes = state.providerRes as ProviderResponse;
    contentFromSuccRequest = providerRes.orderCompletionText || '';
  }

  if (!state) {
    return null;
  }

  const { isResponseOk } = state;

  const { bodyContent, headingContent, iconBackground } = isResponseOk
    ? succesfulContent
    : unSuccesfulContent;

  const transformContent = {
    ...headingContent,
    title: headingContent.title.replaceAll('{dynamicProvider}', provider),
  };

  return (
    <CheckoutTopNotificationWrapper
      heading={transformContent}
      productFieldName="overview.selectedProduct"
      content={
        isResponseOk && !bodyContent ? contentFromSuccRequest : bodyContent
      }
      iconBackground={iconBackground}
    />
  );
};
